import {ItemType} from "../entity/index.entity";

export const saveCartToLocalStorage = (userId : string, cart : ItemType[]) => {
    localStorage.setItem(`cart_${userId}`, JSON.stringify(cart));
};

export const loadCartFromLocalStorage = (userId : string) => {
    const cart = localStorage.getItem(`cart_${userId}`);
    return cart ? JSON.parse(cart) : [];
};

export const getUserId = () => {
    let userId = localStorage.getItem('userId');
    if (!userId) {
        userId = 'user_' + Math.random().toString(36).substr(2, 9);
        localStorage.setItem('userId', userId);
    }
    return userId;
};